import { render, staticRenderFns } from "./LogsComponent.vue?vue&type=template&id=6b4da125"
import script from "./LogsComponent.vue?vue&type=script&lang=js"
export * from "./LogsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports